import type { SanityAnchorPoint } from '#/lib/sanity/queries/sections';

export function AnchorPoint(props: SanityAnchorPoint) {
  return <div id={props.id} />;
}
